import { IDatePickerStrings } from 'office-ui-fabric-react/lib/DatePicker';
import HeadingObj from '../Entity/headingobj';
import {ViewTotal} from  '../Entity/ViewTotal';

export class MIAPACons{
     public static DayPickerStrings: IDatePickerStrings = {
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      
        shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      
        goToToday: 'Go to today',
        prevMonthAriaLabel: 'Go to previous month',
        nextMonthAriaLabel: 'Go to next month',
        prevYearAriaLabel: 'Go to previous year',
        nextYearAriaLabel: 'Go to next year',
        //closeButtonAriaLabel: 'Close date picker'
      };
      public static GraphAPI={
        GraphBaseURL: 'https://graph.microsoft.com/',
        ME:'v1.0/me',
        PlannerTaks: 'v1.0/planner/tasks',
        PlannerTaksbeta: 'beta/planner/tasks',
        MyTasks: 'v1.0/me/planner/tasks',
        //MyTasks: 'v1.0/users/42d98754-602e-4038-80f7-4789e10af55d/planner/tasks',
        MyTasksBeta:'beta/me/planner/tasks',
        //MyTasksBeta:'beta/users/42d98754-602e-4038-80f7-4789e10af55d/planner/tasks',
        PlanTaks: 'v1.0/planner/plans/{0}/tasks',
        PlanTaksBeta: 'beta/planner/plans/{0}/tasks',
        TaskDetail: 'v1.0/planner/tasks/{0}/details?v=',
        Plans: 'v1.0/me/planner/plans',
        Plan: 'v1.0/planner/plans/{0}',
        PlanDetails: "v1.0/planner/plans/{0}/details",
        PlanDetailsbeta: "beta/planner/plans/{0}/details",
        PlanBuckets: 'v1.0/planner/plans/{0}/buckets',
        Users: 'v1.0/users',
        MyEvents: 'v1.0/me/events',
        MyCalenderView: 'v1.0/me/calendar/calendarView',
        MyOutlookTasks: 'beta/me/outlook/tasks',
        GroupPosts: 'v1.0/groups/{0}/threads/{1}/posts?v=',
        GroupMembers: 'v1.0/groups/{0}/members',
        Organization:'v1.0/organization',
        MyFlagEmails: 'v1.0/me/messages',
        rootsite:'v1.0/sites/root',
        MySite:'v1.0/me/mySite',
        GroupWeb: "v1.0/groups/{0}/drive/root/webUrl",
        MyContacts:'v1.0/me/contacts',
        MyEmailAttachments:'v1.0/me/messages/{0}/attachments',
        MyRecentFiles:'v1.0/me/drive/recent',
        SharedWithMe:'v1.0/me/drive/sharedWithMe',
        MyAttachments:"v1.0/me/insights/shared?$top=50&$filter=lastShared/sharingType eq 'Attachment'",
        DirectReporters:'v1.0/me/directReports',
        GroupConversation: "v1.0/groups/{0}/conversations",
        PlannerTask: 'v1.0/planner/tasks/{0}',
        GroupReply: "v1.0/groups/{0}/threads/{1}/reply",
    };
    public static MenuOption ={options: ['Meetings', 'SSO' , 'PlannerTask', 'Events', 'TODOS', 'FlaggedEmail','MSList']} ;
    public static MIPAState = {      
      Meetings: {
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late:new Array(),
      },
      SSO: {
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Probability: new Array(),
        Phases: new Array(),
        LogTitle:'',
        Late:new Array(),
      },
      PlannerTask:{
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        //Overdue:new Array(),
        WithoutdueDate:new Array(),
        Late:new Array(),
      },
      Events: {
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late:new Array(),
      },
      TODOS: {
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late:new Array(),
      },
      FlaggedEmail:{
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late:new Array(),
      },
      MSList:{
        Today: new Array(),
        ThisWeek: new Array(),
        NextWeek: new Array(),
        Late:new Array(),
      },
      MyRecentFiles:new Array(),
      SharedItems:new Array(),
      AttachmentItems:new Array(),
      ToDayCol: new HeadingObj('today', 0, MIAPACons.MenuOption.options.slice()),
      ThisWeekCol: new HeadingObj('thisweek', 1, MIAPACons.MenuOption.options.slice()),
      NextWeekCol: new HeadingObj('nextweek', 2, MIAPACons.MenuOption.options.slice()),
      RecentCol: new HeadingObj('recentfiles', 1, MIAPACons.MenuOption.options.slice()),
      SharedCol: new HeadingObj('sharedfiles', 2, MIAPACons.MenuOption.options.slice()),
      AttachmentCol: new HeadingObj('attachmentfrommailbox', 3, MIAPACons.MenuOption.options.slice()),
      GraphUsers: new Array(),
      Calview: 0,
      isLoading: true,
      //ColViewTotal:new ViewTotal(),
      TodayTotal:new ViewTotal(),
      ThisWeekTotal:new ViewTotal(),
      NextWeekTotal:new ViewTotal(),
      LateTotal:new ViewTotal(),
      ShowLogin:false,
      ShowMessage:'',
      ComponetName:'',
      activitytitle:'',
      showweekend:false,
      AdminEmail: '',
      ShowNewPlanTaskWindow:false,
      ShowMysettingWindow:false,
      Dashboard:1,
      TriggerReloadPlannerTasksInPlannerDashboard: false
    };
}
